import { useState } from '#app';

export const usePreloaderState = () => {
	const isFinished = useState('preloaderIsFinished', () => false);

	return {
		isFinished,
	};
};
